import { render, staticRenderFns } from "./CreateCampaignSource.vue?vue&type=template&id=53424e12"
import script from "./CreateCampaignSource.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports